import locales from '@/store/locales'

export default {
  localeLink: ({ locale }) => (path = '') => {
    return '/' + locale + path
  },
  localeList: ({ locale }) => (list = []) => {
    if (!list) return
    return list.map(i => i[locale])
  },
  localeItem: ({ locale }) => (obj = {}) => {
    if (!obj) return
    return obj[locale]
  },
  $t: ({ locale }) => (section, name) => {
    const loc = locale || 'en'
    return locales[loc][section][name]
  },
  single ({ locale, single }) {
    if (!single) return null
    return single[locale]
  },
  book ({ locale, book }) {
    if (!book) return null
    return book[locale]
  },
  weather (state) {
    return state.weather
  }
}
